import { makeStyles } from "@material-ui/core";
const FTLTableBodyStyles = makeStyles({
    root: ({ showHeader, showFooter, }) => ({
        height: "100%",
        width: "100%",
        display: "block",
        "& tr:last-child": {
            "&:before, &:after": showHeader || showFooter
                ? {
                    content: "@",
                    display: "block",
                    lineHeight: 4,
                    textIndent: -99999,
                }
                : {},
        },
    }),
});
export default FTLTableBodyStyles;
//# sourceMappingURL=FTLTableBodyStyles.styles.js.map